import React, {useEffect, useState} from 'react';
import {useStore} from "zustand";
import {Layout, Menu, MenuProps} from 'antd';
import {useLocation, useNavigate} from 'react-router-dom';
import classNames from "classnames";
import {useMediaQuery} from "react-responsive";
import {
  CalendarOutlined,
  CarOutlined,
  CodeOutlined,
  CreditCardOutlined,
  DollarOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  EditOutlined,
  MessageOutlined,
  NotificationOutlined,
  TeamOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import styles from './Sider.module.scss'
import {useAuthStore} from "../../../stores/authStore";
import {RoleType} from "../../../types/Role";

const { Sider: AntSider } = Layout;
type MenuItem = Required<MenuProps>['items'][number];

const businessMenuItems: MenuItem[] = [
  {
    key: 'grp1',
    label: '운영업무',
    type: 'group',
    children: [
      {
        key: '/app/business/cashManage',
        icon: <DollarOutlined />,
        label: '캐쉬 요청',
      },
	    {
		    key: '/app/business/userList',
		    icon: <TeamOutlined />,
		    label: '회원 조회',
	    },
	    {
		    key: '/app/business/carList',
		    icon: <CarOutlined />,
		    label: '모배 차량 조회',
	    },
      {
        key: '/app/business/cashPeriod',
        icon: <CalendarOutlined />,
        label: '일별 입출금',
      },
      {
        key: '/app/business/pointAdjust',
        icon: <EditOutlined />,
        label: '점수 조정',
      },
      {
        key: '/app/business/notice',
        icon: <NotificationOutlined />,
        label: '공지사항',
      },
      {
        key: '/app/business/fcmMessage',
        icon: <MessageOutlined />,
        label: 'FCM 메시지',
      },
      // // 레거시
      // {
      //   key: '/app/business/baechaList',
      //   icon: <UnorderedListOutlined />,
      //   label: '배차 조회',
      // },
      {
        key: '/app/business/baechaList2',
        icon: <UnorderedListOutlined />,
        label: '배차 조회',
      },
      {
        key: '/app/business/subscriptionList',
        icon: <CreditCardOutlined />,
        label: '구독 조회',
      },
      // {
      //   key: '/app/business/baechaGroupList',
      //   icon: <TeamOutlined />,
      //   label: '배차방 조회',
      // },
      // {
      //   key: '/app/business/cashStatics',
      //   label: '사용자 캐쉬 현황',
      // },
    ],
  },
  {
    type: 'divider',
  },
];

const systemMenuItems: MenuItem[] = [
  {
    key: 'grp2',
    label: '시스템',
    type: 'group',
    children: [
      {
        key: '/app/system/batchRun',
        icon: <CodeOutlined />,
        label: '배치 실행',
      },
	    {
		    key: '/app/system/geoSetup',
		    icon: <CodeOutlined />,
		    label: '주소 업로드',
	    },
      {
        key: '/app/system/subscription/ack',
        icon: <CodeOutlined />,
        label: '구독 ack 처리',
      },
      // {
      //   key: '/app/business/cashStatics',
      //   label: '사용자 캐쉬 현황',
      // },
      {
        type: 'divider',
      },
    ],
  },
];

interface SiderProps {
  collapsed: boolean;
  onCollapse: () => any;
}

const Sider = ({ collapsed, onCollapse }: SiderProps) => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const location = useLocation();
  const navigate = useNavigate();
  const { roles } = useStore(useAuthStore);

  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);

  const onClick: MenuProps['onClick'] = (e) => {
    navigate(e.key);
    if (isTabletOrMobile) {
      onCollapse();
    }
  };


  const getHasBusinessRole = (roles: RoleType[]) => roles.includes('business_admin')
    || roles.includes('business_operator');

  const getHasSystemRole = (roles: RoleType[]) => roles.includes('system_admin')
    || roles.includes('system_operator');

  const getDefaultSelectedKeys = () => {
    const hasBusinessRole = getHasBusinessRole(roles);
    const hasSystemRole = getHasSystemRole(roles);
    if (hasBusinessRole) {
      return ['/app/business/cashManage'];
    }
    if (hasSystemRole) {
      return ['/app/system/batchRun'];
    }
    return [];
  };

  useEffect(() => {
    let newMenuItems: MenuItem[] = [];
    const hasBusinessRole = getHasBusinessRole(roles);
    const hasSystemRole = getHasSystemRole(roles);
    if (hasBusinessRole) {
      newMenuItems = [...newMenuItems, ...businessMenuItems];
    }
    if (hasSystemRole) {
      newMenuItems = [...newMenuItems, ...systemMenuItems];
    }
    setMenuItems(newMenuItems);
  }, [roles]);

  return (
    <AntSider
      className={classNames(styles.sider, {
        [styles.collapsed]: collapsed,
      })}
      breakpoint="lg"
      collapsedWidth={isTabletOrMobile ? 0 : 80}
      width={256}
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      trigger={null}
    >
      <Menu
        onClick={onClick}
        defaultSelectedKeys={getDefaultSelectedKeys()}
        mode="inline"
        items={menuItems}
        selectedKeys={[location.pathname]}
      />
      <div className={styles.bottom}>
        {!collapsed && <p>Platmatch Inc.</p>}
        <div onClick={onCollapse}>
          {collapsed ? <DoubleRightOutlined /> : <DoubleLeftOutlined />}
        </div>
      </div>
    </AntSider>
  );
};

export default Sider;
